export default "__VITE_ASSET__af7f6ca4__"